import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { SET_SUCCESS_PROMPT_SMP_DISRUPTION } from "../../../store/actionTypes/bplrt/smpActionType";
import { useTranslation } from "react-i18next";

const DisruptionSuccessPrompt = () => {
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation();

  const {
    isSuccessPromptSMPDisruptionPage: isSuccess,
    successMessageSMPDisruptionPage: successMessage,
  } = useSelector((state) => state.bplrtSmp);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_SUCCESS_PROMPT_SMP_DISRUPTION, payload: false });
  };

  return (
    isSuccess && (
      <Alert
        sx={{ my: 2 }}
        severity="success"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{tCommon("successPromptTitle")}</AlertTitle>
        {successMessage}
      </Alert>
    )
  );
};

export default DisruptionSuccessPrompt;
